var map = {
	"./icon-ae.png": 4583,
	"./icon-aipg.png": 8310,
	"./icon-aleo.png": 5851,
	"./icon-alph.png": 8079,
	"./icon-avs.png": 8577,
	"./icon-bch.png": 4926,
	"./icon-beam.png": 535,
	"./icon-bel.png": 8482,
	"./icon-blocx.png": 6483,
	"./icon-btc.png": 963,
	"./icon-btn.png": 7873,
	"./icon-cau.png": 7590,
	"./icon-cfx.png": 4527,
	"./icon-ckb.png": 5352,
	"./icon-clo.png": 6659,
	"./icon-clore.png": 3010,
	"./icon-ctxc.png": 2284,
	"./icon-dash.png": 5717,
	"./icon-dcr.png": 3744,
	"./icon-dnx.png": 5883,
	"./icon-dogether.png": 8683,
	"./icon-dubx.png": 2530,
	"./icon-egaz.png": 2064,
	"./icon-elh.png": 5785,
	"./icon-enox.png": 9676,
	"./icon-erg.png": 6607,
	"./icon-etc+zil.png": 6901,
	"./icon-etc.png": 2402,
	"./icon-eth.png": 8004,
	"./icon-ethf+zil.png": 3473,
	"./icon-ethf.png": 3492,
	"./icon-ethw+zil.png": 7275,
	"./icon-ethw.png": 8478,
	"./icon-flux.png": 7454,
	"./icon-grin.png": 9122,
	"./icon-hns.png": 3048,
	"./icon-iron.png": 5526,
	"./icon-kas(>6.5t).png": 602,
	"./icon-kas(ks0,1,2).png": 1801,
	"./icon-kas(ks3).png": 1752,
	"./icon-kaspa.png": 7376,
	"./icon-kda.png": 3053,
	"./icon-kls.png": 1908,
	"./icon-lbc.png": 2135,
	"./icon-logo-blue.png": 3089,
	"./icon-ltc.png": 3765,
	"./icon-maxe.png": 6459,
	"./icon-mecu.png": 2191,
	"./icon-meow.png": 4245,
	"./icon-mewc.png": 1139,
	"./icon-neox.png": 3034,
	"./icon-neoxa.png": 4324,
	"./icon-neurai.png": 9200,
	"./icon-nevo.png": 8213,
	"./icon-nexa.png": 5698,
	"./icon-nginx.png": 1591,
	"./icon-niki.png": 4445,
	"./icon-octa.png": 1662,
	"./icon-pac.png": 50,
	"./icon-pwr.png": 4554,
	"./icon-pyi.png": 1258,
	"./icon-redev2.png": 4120,
	"./icon-rtc.png": 9721,
	"./icon-rth.png": 4261,
	"./icon-rtm.png": 5214,
	"./icon-rvn.png": 867,
	"./icon-rxd.png": 1868,
	"./icon-sc.png": 6167,
	"./icon-sdr(gpu).png": 9757,
	"./icon-sdr(ks0,1,2).png": 1654,
	"./icon-sdr(ks3).png": 9525,
	"./icon-sero.png": 7514,
	"./icon-space.png": 7754,
	"./icon-subi.png": 3769,
	"./icon-trm.png": 7557,
	"./icon-ubq.png": 5693,
	"./icon-xmr.png": 8903,
	"./icon-xpb.png": 5803,
	"./icon-zec.png": 9467,
	"./icon-zen.png": 8619,
	"./icon-zeph.png": 9061,
	"./icon-zil.png": 3059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9213;